module.exports = __webpack_public_path__ + "static/img/coin.01e199e2.png";